import {
	baseApiHeaders,
	HIDE_TOAST_KEY,
	type IApiResponse,
	type ITeamMemberData,
	type ITeamMembers,
	type ParamType,
} from 'BreetHelpers';

import { apiSlice } from './apiSlice';

export const teamsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getTeamMembers: builder.query<IApiResponse<ITeamMembers[]>, ParamType>({
			query: (params) => ({ url: '/users/business/teams', params }),
			providesTags: ['AllTeamMembers'],
		}),
		getTeamMemberById: builder.query<IApiResponse<ITeamMemberData>, string>({
			query: (id) => ({ url: `/users/business/teams/${id}` }),
		}),
		inviteTeamMember: builder.mutation<IApiResponse, { email: string; fullName: string; role: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/users/business/teams/invite',
				body,
			}),
			invalidatesTags: ['AllTeamMembers'],
		}),
		updateTeamMemberById: builder.mutation<IApiResponse, { id: string; role: string; customPermissions?: string[] }>({
			query: ({ id, ...body }) => ({
				method: 'PATCH',
				url: `/users/business/teams/${id}`,
				body,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
			invalidatesTags: ['AllTeamMembers'],
		}),
		redeemTeamMemberInvite: builder.mutation<IApiResponse, { token: string; password?: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/auth/redeem-invite',
				body,
			}),
		}),
		resendTeamMemberInvite: builder.mutation<IApiResponse, { memberId: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/users/business/teams/invite/resend',
				body,
			}),
			invalidatesTags: ['AllTeamMembers'],
		}),
		deleteTeamMemberById: builder.mutation<IApiResponse, string>({
			query: (id) => ({
				method: 'DELETE',
				url: `/users/business/teams/${id}`,
			}),
			invalidatesTags: ['AllTeamMembers'],
		}),
	}),
});

export const {
	useGetTeamMembersQuery,
	useGetTeamMemberByIdQuery,
	useInviteTeamMemberMutation,
	useDeleteTeamMemberByIdMutation,
	useRedeemTeamMemberInviteMutation,
	useResendTeamMemberInviteMutation,
	useUpdateTeamMemberByIdMutation,
} = teamsApiSlice;
